import { mapState } from 'vuex'

export default {
  computed: {
    categoryFilters() {
      let p = this.category.currentPath.split('/')
      let slug = p[0] === 'used' ? p[1] : p[0]
      let filters = this.$h.clone(this.filters.find(f => f.category === slug))
      if (
        this.category.filters.model &&
        p[1] === this.category.filters.model[0] &&
        this.category.filters.model.length === 1
      ) {
        let attrs = filters.attributes.filter(f => f.slug !== 'model')
        filters.attributes = attrs
      }
      if (this.category.currentPath.includes('used')) {
        let attrs = filters.attributes.filter(f => f.slug !== 'new-or-used')
        filters.attributes = attrs
      }
      function applyArrivedFilters(array, filterer) {
        return array
          .map(el => {
            const { ...newElement } = el
            newElement.options = el.options.filter(
              option =>
                filterer[el.slug] && filterer[el.slug].includes(option.slug)
            )
            return newElement
          })
          .filter(a => a.options.length)
      }
      // skip used filter in used category and not matched filters
      if (Object.keys(this.category.filters).length) {
        return applyArrivedFilters(filters.attributes, this.category.filters)
        // return filters.attributes.filter((a) => {
        //   if (!this.category.filters[a.slug]) {
        //     return false
        //   }
        //   return true
        // })
      } else {
        return filters.attributes
      }
    },
    ...mapState(['category', 'filters']),
  },
}
